import { render, staticRenderFns } from "./salesSummary.vue?vue&type=template&id=54a5e94e&scoped=true"
import script from "./salesSummary.vue?vue&type=script&lang=js"
export * from "./salesSummary.vue?vue&type=script&lang=js"
import style0 from "./salesSummary.vue?vue&type=style&index=0&id=54a5e94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5e94e",
  null
  
)

export default component.exports